import _CloseIcon from "@/components/ui/icon/cross";

export const CloseIcon = () => (
	<_CloseIcon size="sm" className="cursor-pointer  rounded-full bg-black text-bg-layer-50 hover:opacity-70" />
);
